import Vue from 'vue'
import VueResource from 'vue-resource'
import mixins from '../mixins.js'
import toastr from '../toastr'
import Singleselect from '../../component/singleselect.vue'
import Checkbox from '../../component/simple-form/checkbox.vue'
import History from './history.vue'

if ($('#purchase_order_show_form').length) {
  Vue.use(VueResource)

  new Vue({
    el: '#purchase_order_show_form',
    components: {
      Singleselect,
      Checkbox,
      History
    },
    mixins: [mixins],
    data: {
      warehouses: [],
      warehouseSK: [],
      loading: 0,
      order: {
        items: {},
      },
      orderId: null,
      actualItemsNo: 0,
    },
    mounted: function () {
      this.loading++

      this.orderId = $('#purchase_order_input_id').val()
      this.getPurchaseOrder()
      this.getWarehouses()

      this.loading--
    },
    methods: {
      createWarehouseEntry: function (redirect) {
        let url = Routing.generate('api_accept_purchase_order_order')
        this.$http.post(url, {
          'id': this.orderId,
          'items': this.order.items,
        }).then(() => {
          if (redirect) {
            $(location).attr('href', Routing.generate('purchase_order_show', { id: this.orderId }))
          } else {
            toastr.success(Translator.trans('form.updated'))
          }
        }, response => {
          this.handleAjaxError(response)
        })
      },
      getPurchaseOrder: function () {
        let url = Routing.generate('api_get_purchase_order', { id: this.orderId,
          context: 'edit' })
        this.loading++
        this.$http.get(url).then(response => {
          this.order = response.data
          this.order.items = this.order.itemsForShow
          this.actualItemsNo = Object.keys(this.order.items).length
          delete this.order.itemsForEdit
          delete this.order.itemsForShow

          this.calculateAmountToAccept()
          this.checkItems()
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },
      calculateAmountToAccept() {
        for (let i in this.order.items) {
          this.order.items[i].toAccept = Math.max(
            0,
            this.order.items[i].amount - this.order.items[i].amountAccepted
          )
        }
      },
      checkItems() {
        for (let i in this.order.items) {
          this.order.items[i].checked = true
        }
      },
      getWarehouses: function () {
        let url = Routing.generate('api_get_warehouses', { context: 'dropdown' })
        this.loading++
        this.$http.get(url).then(response => {
          this.warehouses = response.data

          for (let i = 0; i < this.warehouses.length; i++) {
            if (this.warehouses[i].symbol === 'SK') {
              this.warehouseSK = this.warehouses[i]
            }
          }

          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },
      checkAcceptValue(i) {
        let valueToAccept = parseFloat(this.order.items[i].toAccept)

        if (isNaN(valueToAccept)) {
          valueToAccept = 0
          this.order.items[i].toAccept = valueToAccept
        }
      },
    },
  })
}
